import { getRectFromCoordinates, getShadowRoot, findClosestPositionContainer } from "../../../utilities/dom/index.js";
import calculatePosition from "./calculatePosition.js";
import getPositionFallbacks from "./getPositionFallbacks.js";
import isFullyVisible from "./isFullyVisible.js";
import { resetStyles } from "../Flyout.constants.js";
/**
 * Set position of the target element to fit on the screen
 */
const flyout = (args) => {
    const { triggerEl, flyoutEl, triggerBounds: passedTriggerBounds, contentShift = 0, contentGap = 0, position, fallbackPositions, width, container: passedContainer, lastUsedPosition, onPositionChoose, rtl, } = args;
    const targetClone = flyoutEl.cloneNode(true);
    const baseUnit = getComputedStyle(flyoutEl).getPropertyValue("--rs-unit-x1");
    const unitModifier = baseUnit ? parseInt(baseUnit) : 4;
    const triggerBounds = passedTriggerBounds || triggerEl?.getBoundingClientRect();
    if (!triggerBounds)
        return;
    const resolvedTriggerBounds = getRectFromCoordinates(triggerBounds);
    // Reset all styles applied on the previous hook execution
    targetClone.style.cssText = "";
    Object.keys(resetStyles).forEach((key) => {
        const value = resetStyles[key];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (value)
            targetClone.style[key] = value.toString();
    });
    if (width === "trigger") {
        targetClone.style.width = `${resolvedTriggerBounds.width}px`;
    }
    else if (width && width !== "full") {
        targetClone.style.width = width;
    }
    const shadowRoot = triggerEl && getShadowRoot(triggerEl);
    // Insert inside shadow root if possible to make sure styles are applied correctly
    (shadowRoot || document.body).appendChild(targetClone);
    const cloneRect = targetClone.getBoundingClientRect();
    const flyoutBounds = { width: cloneRect.width, height: cloneRect.height };
    const closestFixedContainer = !passedContainer && triggerEl ? findClosestPositionContainer({ el: triggerEl }) : undefined;
    const container = passedContainer ||
        // Render inside fixed position container automatically to keep their position synced on scroll
        closestFixedContainer ||
        document.body;
    const renderContainerBounds = container.getBoundingClientRect();
    const visualContainerBounds = (passedContainer || document.body).getBoundingClientRect();
    let calculated = null;
    const testOrder = getPositionFallbacks(position, fallbackPositions);
    testOrder.some((currentPosition) => {
        const tested = calculatePosition({
            triggerBounds: resolvedTriggerBounds,
            flyoutBounds,
            containerBounds: renderContainerBounds,
            position: currentPosition,
            contentGap: contentGap * unitModifier,
            contentShift: contentShift * unitModifier,
            rtl,
            width,
            passedContainer,
        });
        const visible = isFullyVisible({
            flyoutBounds: tested.boundaries,
            visualContainerBounds,
            renderContainerBounds,
            container,
        });
        const validPosition = visible || fallbackPositions?.length === 0;
        // Saving first try in case none of the options work
        if (validPosition || lastUsedPosition === currentPosition) {
            calculated = tested;
            onPositionChoose(currentPosition);
        }
        return validPosition;
    });
    if (!calculated) {
        throw new Error(`[Reshaped] Can't calculate styles for the ${position} position`);
    }
    targetClone.parentNode?.removeChild(targetClone);
    return calculated;
};
export default flyout;
